const DownloadResume = (base64Data, fileName) => {
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Detect MIME type
  let mimeType = "application/pdf";
  let extension = "pdf";
  if (base64Data.includes("JVBER")) {
    mimeType = "application/pdf";
    extension = "pdf";
  } else {
    mimeType =
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    extension = "docx";
  }

  const blob = new Blob([byteArray], { type: mimeType });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default DownloadResume;
